import React, {memo} from 'react';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import DisplayImage from '../display-image';
import {colors, fontFamily, fontWeight, fontSize} from '@/styles/tokens';
import styles from './result.module.scss';

// ─── sx objects — module-level constants ──────────────────────────────────────
const plantLeftImgSx = {
    position: 'absolute',
    left: 0,
    '@media (max-width:430px)': {display: 'none'}
} as const;

const resultFooterHeadingSx = {
    fontFamily: fontFamily.heading,
    fontSize: fontSize[48],
    fontWeight: fontWeight.bold,
    color: colors.text.primary
} as const;

// Migrated from globals.scss bare `.result-grid-text`: base rule (already migrated
// previously) plus the two remaining breakpoint overrides on the same selector —
// `@include tabScreen` (max-width:768px, font-size:65px) and `@include mobileScreen()`
// (max-width:430px, display:none + right:-45px). Sole owner confirmed for all three.
// Preserved as-is, untouched, and left global in globals.scss: `.friend-spire-main-parent
// .result-grid-text` and `.ifinca-study-main-parent .result-grid-text` — page-wrapper-scoped
// 1199px font-size overrides owned by their respective case-study pages, out of scope here.
const resultGridTextSx = {
    fontFamily: fontFamily.heading,
    fontSize: '80px',
    fontWeight: fontWeight.bold,
    color: colors.text.inverse,
    opacity: 0.5,
    position: 'absolute',
    transform: 'rotate(90deg)',
    top: '40%',
    right: '-40px',
    '@media (max-width:768px)': {fontSize: `${fontSize[65]} !important`},
    '@media (max-width:430px)': {
        display: 'none !important',
        right: '-45px !important' // no exact token match — preserved for parity
    }
} as const;

const resultGridWrapperSx = {
    '@media (max-width:600px)': {marginTop: 0}
} as const;

const resultImgBoxSx = {
    '@media (max-width:768px)': {textAlign: 'center'}
} as const;

const resultGridContainerSx = {textAlign: 'center'} as const;

const rightMarginSx = {
    paddingRight: '50px',
    '@media (max-width:430px)': {paddingRight: 0}
} as const;

const Result = (props: any) => {
    const {
        heading,
        resultcontent,
        resultcontenttwo,
        gridimg,
        plantleft,
        gridimgclass,
        gridtextclass,
        gridsidetext,
        className,
        resultfooterData,
        resultheadimgclass,
        friendsimgclass,
        contenttwoclass,
        gridTextSx,
        headingSx,
        contentSx,
        gridImgSx,
        headImageSx,
        friendImageSx
        // resultcontentclass
    } = props;
    return (
        <MUIBox>
            <MUIBox sx={plantLeftImgSx}>
                <DisplayImage src={plantleft} alt="Result plant image" className={`${resultheadimgclass}`} sx={headImageSx} />
            </MUIBox>
            <MUITypography className={`${className} margin center`} sx={headingSx}>
                {heading}
            </MUITypography>
            <MUIBox className="divder-wrapper perfect-blockchain-divider-wrapper">
                <hr className="divider-line top-spacing" />
            </MUIBox>
            <MUIGrid container className="top-spacing" sx={resultGridWrapperSx}>
                <MUIGrid item xs={12} sm={12} md={7} lg={7}>
                    <MUITypography className={`${contenttwoclass} blockchain-para`} sx={{...rightMarginSx, ...contentSx}}>
                        {resultcontent}
                    </MUITypography>
                    <MUITypography className={`${contenttwoclass} blockchain-para`} sx={{...rightMarginSx, ...contentSx}}>
                        {resultcontenttwo}
                    </MUITypography>
                </MUIGrid>
                <MUIGrid item xs={12} sm={12} md={5} lg={5} className={`${gridimgclass}`} sx={gridImgSx}>
                    <MUIBox sx={resultImgBoxSx}>
                        <DisplayImage
                            src={gridimg}
                            alt="client"
                            className={`${styles.resultGridImg} ${friendsimgclass}`}
                            width={413}
                            height={506}
                            sx={friendImageSx}
                        />
                        <MUITypography className={`result-grid-text ${gridtextclass || ''}`} sx={{...resultGridTextSx, ...gridTextSx}}>
                            {gridsidetext}
                        </MUITypography>
                    </MUIBox>
                </MUIGrid>
            </MUIGrid>

            <MUIGrid container sx={resultGridContainerSx}>
                {resultfooterData?.map((data: any, index: any) => (
                    <MUIGrid item xs={6} sm={4} md={2} lg={2} className="top-spacing" key={index}>
                        <MUITypography sx={resultFooterHeadingSx}>{data.heading}</MUITypography>
                        <MUITypography className="client-intro">{data.subheading}</MUITypography>
                    </MUIGrid>
                ))}
            </MUIGrid>
        </MUIBox>
    );
};
export default memo(Result);
